export const UMB_IN_MODAL_CONDITION_ALIAS = 'Umb.Condition.InModal';
